<template>
  <div>
    <div class="demandes-count">
      <slot name="count" />
      <span style="float: right;">
        <b-overlay
          :show="!loading && reloading"
          :variant="'white'"
          rounded="lg"
          opacity="0.9"
        >
          <template #overlay>
            <div class="d-flex align-items-center">
              <b-spinner
                small
                variant="secondary"
              />
            </div>
          </template>
          <div v-if="count > 0">
            {{ count }} {{ $tc('words.request', count) }}
          </div>
        </b-overlay>
      </span>
    </div>
    <b-overlay
      id="overlay-background"
      :show="loading"
      :variant="'white'"
      :opacity="0.6"
      rounded="sm"
      blur="2px"
      style="width: 100%; min-height: 6rem;"
    >
      <slot name="item" />
      <div
        v-if="count === 0 && !loading"
        class="no-demandes"
      >
        <slot name="empty" />
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'AccountsDemandesList',

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    reloading: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
  }
};
</script>

<style lang="less" scoped>
.demandes-count {
  width: 100%;
  right: 1em;
  top: 0.5em;
  margin-bottom: 0.1em;
}

.b-overlay .position-absolute {
  height: 97%;
}

.no-demandes {
  text-align: right;
  font-style: italic;
  color: rgb(82, 82, 82);
  font-size: 0.9em;
  margin-top: 1rem;
}
</style>